export default "__VITE_ASSET__E3oX85b8__"